import React, { useState, useEffect } from 'react'
import Controllers from '../../Api/Controllers';
import ImagesForm from './ImagesForm'
import Helpers from '../../Components/Helpers/Helpers';
import { SurfaceCard, SideDrawer, EmptyState } from '../../Components/Ui'
import ReactPlaceholder from 'react-placeholder/lib';

const ImagesModal = ({ modalShow, handleHideModalForm, addImage }) => {

    const [ready, setReady] = useState(false)
    const [listImages, setListImages] = useState([])
    const [reload, setReload] = useState(true)

    useEffect(() => {
        if (reload) {
            setReady(false)
            Controllers.images.get_images().then(res => {
                setListImages(res.data)
                setReady(true)
                setReload(false)
            })
        }
    }, [reload])

    return (
        <SideDrawer
            open={modalShow}
            onClose={handleHideModalForm}
            title="Imágenes Multimedia"
            eyebrow="Galería"
            subtitle="Carga una nueva imagen o selecciona una existente."
            width="min(640px, 96vw)"
        >
            <ImagesForm callbackSuccess={() => setReload(true)} />
            <SurfaceCard className="mt-4" title={<><i className="fa fa-list mr-1"></i>Listado de Imágenes</>}>
                <ReactPlaceholder ready={ready} showLoadingAnimation>
                    {!ready ? null : listImages.length === 0 ? (
                        <EmptyState
                            title="Sin imágenes"
                            text="Aún no hay imágenes cargadas. Sube la primera desde el formulario."
                        />
                    ) : (
                        <div className="form-row">
                            {React.Children.toArray(listImages.map(l => {
                                return <div className="col-6 col-md-4 mb-3" onClick={_ => {
                                    addImage(l)
                                    handleHideModalForm()
                                }}>
                                    <img className="img-thumbnail hover-effect cur-pointer" src={Helpers.config.resourcesUrl({ url: l.file_images })} alt={l.alt_images || ''} />
                                </div>
                            }))}
                        </div>
                    )}
                </ReactPlaceholder>
            </SurfaceCard>
        </SideDrawer>
    )
}

export default ImagesModal
